<template>
  <div>
    <page-header :actions="headerActionConfig" :page="pageOptions" />
    <validation-observer ref="accountNumberRef" novalidate tag="form">
      <div>
        <section-title has-line title="Añadir Cifras de Cuentas" />
      </div>
      <div class="bg-secondary-1 p-3 rounded">
        <div class="row">
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="model.dateFrom"
                custom-error-msg="Favor seleccionar la fecha desde."
                :error="errors[0]"
                label="Fecha Desde:"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
            <error
              v-if="validations.invalidDate"
              :message="validations.invalidDate"
              variant="no-border mt-1"
            />
          </div>
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="model.dateTo"
                custom-error-msg="Favor seleccionar la fecha hasta."
                :error="errors[0]"
                label="Fecha Hasta:"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.hiringType"
                :clearable="false"
                custom-error-msg="Favor seleccionar el Tipo de Contratación."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Contratación:"
                :options="catalog.hiringTypes"
                placeholder="Seleccione"
                @input="onChangeHiringTypeHandler"
              />
            </validation-provider>
          </div>
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.figureType"
                :clearable="false"
                custom-error-msg="Favor seleccionar el Tipo de Cifra."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Cifra:"
                :options="catalog.figureTypes"
                placeholder="Seleccione"
                @input="onNumberTypeHandler"
              />
            </validation-provider>
          </div>
          <div class="col">
            <validation-provider
              v-slot="{ errors }"
              :rules="
                isProfessionalService && isFederalAccounting ? 'required' : ''
              "
            >
              <custom-drop-down
                id="serviceId"
                v-model="model.serviceId"
                :clearable="false"
                custom-error-msg="Favor seleccionar el Grupo de Edad."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Grupo de Edad:"
                :options="catalog.billingServiceCategories"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
        </div>
        <div v-if="isAssistiveTeam" class="row py-4">
          <div class="col border-right pr-4">
            <validation-observer
              ref="caatDropDown"
              :disabled="true"
              novalidate
              tag="form"
            >
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  id="caat"
                  v-model="model.caat"
                  :clearable="false"
                  custom-error-msg="El centro de servicio es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Centro de Servicio:"
                  :options="availableCaatOptions"
                  placeholder="Seleccione"
                  @input="onChangeCaatHandler"
                />
              </validation-provider>
            </validation-observer>
            <div class="d-flex justify-content-end mt-2">
              <action-button
                i="fas fa-file-plus"
                variant="success"
                @click="onAddCaatHandler"
              >
                Añadir
              </action-button>
            </div>
          </div>
          <div class="col pl-4">
            <div class="color-gray-6 font-16 font-weight-normal mb-2">
              Centro de Servicio Seleccionados
            </div>
            <div
              v-for="(caat, index) in model.caats"
              :key="`caat-row-${index}`"
              class="chip ml-0 bg-white"
            >
              <span class="mr-2">{{ caat.name }}</span>
              <em
                class="far fa-lg fa-times-circle color-red cursor-pointer"
                @click="removeCaatHandler(index)"
              />
            </div>
          </div>
        </div>
        <div
          v-if="!!model.hiringType && !!model.figureType"
          class="bg-white p-3 mt-3 rounded "
        >
          <div class="row">
            <div class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.account"
                  custom-error-msg="Es requerido Account."
                  :error="errors[0]"
                  label="Account:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.dept"
                  custom-error-msg="Es requerido Dept."
                  :error="errors[0]"
                  label="Dept:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.fund"
                  custom-error-msg="Es requerido Fund."
                  :error="errors[0]"
                  label="Fund:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div v-if="isAssistiveTeam || isFederalAccounting" class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.program"
                  custom-error-msg="Es requerido Program."
                  :error="errors[0]"
                  label="Program:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.class"
                  custom-error-msg="Es requerido Class."
                  :error="errors[0]"
                  label="Class:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.budRef"
                  custom-error-msg="Es requerido Bud Ref."
                  :error="errors[0]"
                  label="Bud Ref:"
                  type="number"
                />
              </validation-provider>
            </div>
            <div class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.pcBusUnit"
                  custom-error-msg="Es requerido PC Bus Unit."
                  :error="errors[0]"
                  label="PC Bus Unit:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div
              v-if="
                (isProfessionalService || isAssistiveTeam) &&
                  (isFederalAccounting || isErpEnabled)
              "
              class="col"
            >
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.project"
                  custom-error-msg="Es requerido Project."
                  :error="errors[0]"
                  label="Project:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div v-if="isAssistiveTeam && isFederalAccounting" class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.activity"
                  custom-error-msg="Es requerido Activity."
                  :error="errors[0]"
                  label="Activity:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div v-if="isAssistiveTeam && isErpEnabled" class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.future1"
                  custom-error-msg="Es requerido Future 1."
                  :error="errors[0]"
                  label="Future 1:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div v-if="isAssistiveTeam && isErpEnabled" class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.future2"
                  custom-error-msg="Es requerido Future 2."
                  :error="errors[0]"
                  label="Future 2:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div v-if="isAssistiveTeam && isErpEnabled" class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.future3"
                  custom-error-msg="Es requerido Future 3."
                  :error="errors[0]"
                  label="Future 3:"
                  type="text"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!!model.figureType" class="mt-4 mb-n2">
        <custom-callout class="mb-3 custom-callout">
          <div class="color-secondary-6 font-14">
            Número de Cifra:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ fullNumber }}
          </div>
        </custom-callout>
      </div>
    </validation-observer>

    <div v-if="isDetailView" class="col-md-12 mt-4">
      <section-title has-line title="Utilización de Fondos" />
      <custom-callout class="mb-3 custom-callout">
        <div class="row">
          <div
            class="col-12 border-right d-flex"
            :class="editProjectedFund ? 'col-md-3' : 'col-md-2'"
          >
            <div class="mr-3 w-100">
              <div class="color-secondary-6 font-14">Fondo Proyectado:</div>
              <div v-if="!editProjectedFund" class="font-weight-bold  font-16">
                {{ fundsUse.projectedFund | currency }}
              </div>
              <div v-else class="d-flex w-100">
                <validation-observer
                  ref="formProjectedFundRef"
                  novalidate
                  tag="form"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    class="input"
                    rules="required"
                  >
                    <custom-input
                      id="inputProjectedFund"
                      v-model="projectedFundValue"
                      custom-error-msg="El fondo proyectado es requerido."
                      :error="errors[0]"
                      mask-type="Money"
                    />
                  </validation-provider>
                </validation-observer>
                <div class="ml-2">
                  <action-button
                    class="mr-2"
                    i="fas fa-times-circle"
                    variant="outline-danger"
                    @click="onEditProjectedFundHandler"
                  />
                  <action-button
                    i="fas fa-save"
                    variant="success"
                    @click="onSumbmitProjectedFundHandler"
                  />
                </div>
              </div>
            </div>
            <action-button
              v-if="!editProjectedFund"
              i="fas fa-edit"
              variant="success"
              @click="onEditProjectedFundHandler"
            />
          </div>
          <div class="col-12 col-md-2">
            <div class="color-secondary-6 font-14">Fondo Asignado:</div>
            <div class="font-weight-bold color-green  font-16">
              {{ fundsUse.assignedFunds | currency }}
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="color-secondary-6 font-14">Contratados:</div>
            <div class="font-weight-bold color-black font-16">
              {{ fundsUse.contracted | currency }}
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="color-secondary-6 font-14">Proceso de Pago:</div>
            <div class="font-weight-bold color-black font-16">
              {{ fundsUse.paymentProcess | currency }}
            </div>
          </div>
          <div
            class="col-12"
            :class="editProjectedFund ? 'col-md-1' : 'col-md-2'"
          >
            <div class="color-secondary-6 font-14">Pagado:</div>
            <div class="font-weight-bold color-black font-16">
              {{ fundsUse.paid | currency }}
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="color-secondary-6 font-14">Disponible:</div>
            <div
              v-if="fundsUse.available > 0"
              class="font-weight-bold color-green font-16"
            >
              {{ fundsUse.available | currency }}
            </div>
            <div
              v-if="fundsUse.available <= 0"
              class="font-weight-bold color-red font-16"
            >
              {{ fundsUse.available | currency }}
            </div>
          </div>
        </div>
      </custom-callout>
    </div>
  </div>
</template>

<script>
import { PageHeader } from '@/shared/components/PageHeader/index';
import SectionTitle from '@/components/common/page/SectionTitle';
import { CustomDropDown, Error } from '@/components/common';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import CustomCallout from '@/components/common/CustomCallout';
import ActionButton from 'ActionButton';
import alertMixin from '@/mixins/alert.mixin.js';
import {
  savePurchaseOrders as _savePurchaseOrders,
  getBillingServiceCategories as _getBillingServiceCategories,
  getServiceCenters as _getServiceCenters,
  getFundsUse as _getFundsUse,
  updateProjectFound as _updateProjectFound,
} from '@/modules/shared/provideraccountnumber.api.js';
import { getHiringTypes as _getHiringTypes } from '@/modules/shared/code.api.js';
import hiringTypes from '@/utils/constants/hiringTypes.js';
import CustomInput from 'CustomInput';
import { getFigureType as _getFigureType } from '@/modules/shared/figureType.api.js';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
export default {
  name: 'AccountNumberAdd',
  components: {
    PageHeader,
    SectionTitle,
    CustomDropDown,
    CustomInput,
    CustomCallout,
    CustomDatePicker,
    Error,
    ActionButton,
  },
  mixins: [alertMixin],
  data: () => ({
    isErpEnabled: false,
    fullNumber: '_',
    model: {
      id: null,
      fullNumber: null,
      account: null,
      dept: null,
      fund: null,
      program: null,
      class: null,
      budRef: null,
      pcBusUnit: null,
      project: null,
      activity: null,
      serviceId: null,
      isActive: true,
      dateFrom: null,
      dateTo: null,
      future1: null,
      future2: null,
      future3: null,
      figureTypeId: null,
      caats: [],
      fundsUse: {
        assignedFunds: 0,
        available: 0,
        contracted: 0,
        paid: 0,
        paymentProcess: 0,
      },
    },
    catalog: {
      services: [],
      types: [],
      caats: [],
      billingServiceCategories: [],
      figureTypes: [],
      hiringTypes: [],
    },
    validations: {
      invalidDate: null,
    },
    editProjectedFund: false,
    projectedFundValue: null,
  }),
  computed: {
    isDetailView() {
      return this.$route.params?.id;
    },
    isFederalAccounting() {
      return this.model.figureType.id === 1;
    },
    isStateAccounting() {
      return this.model.figureType.id === 2;
    },
    pageOptions() {
      return {
        title: 'Cifras de Cuentas',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Cifras de Cuentas'],
      };
    },
    headerActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.go(-1);
          },
          visible: true,
        },
        {
          text: this.model.isActive ? 'Inactivar' : 'Activar',
          icon: 'fas fa-power-off',
          variant: this.model.isActive ? 'outline-danger' : 'success',
          click: this.activeHandler,
          visible: !!this.model.id,
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click: this.saveHandler,
          visible: true,
        },
      ];
    },
    statusOptions() {
      return [
        { label: 'Activo', value: true },
        { label: 'Inactivo', value: false },
      ];
    },
    isAssistiveTeam() {
      return [hiringTypes.assistiveTeam].includes(this.model.hiringType?.id);
    },
    isProfessionalService() {
      return [hiringTypes.professionalService].includes(
        this.model.hiringType?.id
      );
    },
    availableCaatOptions() {
      const _added = this.model.caats.map((x) => x.id);
      return this.catalog.caats.filter((x) => !_added.includes(x.id));
    },
  },
  watch: {
    model: {
      handler() {
        this.previewFullNumber();
      },
      deep: true,
    },
  },
  async mounted() {
    await Promise.all([
      this.getAllCaats(),
      this.getAllBillingServiceCategories(),
      this.callGetFigureType(),
      this.getHiringTypes(),
      this.getParam(),
    ]);

    const passModel = this.$route.params;
    if (passModel?.id) {
      var { data } = await _getFundsUse(passModel?.id);
      this.fundsUse = data;
      this.projectedFundValue = data.projectedFund;
      this.model = {
        ...this.model,
        ...passModel,
        hiringType: this.catalog.hiringTypes.find(
          (x) => x.id === passModel.hiringTypeCd
        ),
        figureType: this.catalog.figureTypes.find(
          (x) => x.id === passModel.figureTypeId
        ),
      };
    }
  },
  methods: {
    previewFullNumber() {
      if (this.isAssistiveTeam && this.isErpEnabled) {
        this.fullNumber = [
          this.model.fund ?? '000',
          this.model.pcBusUnit ?? '000',
          this.model.dept ?? '000',
          this.model.program ?? '00000000',
          this.model.budRef ?? '000',
          this.model.class ?? '000000',
          this.model.account ?? '000000',
          this.model.project ?? '000',
          this.model.future1 ?? '000',
          this.model.future2 ?? '000',
          this.model.future3 ?? '000',
        ].join('.');
        return;
      }
      const program = this.model.program ? this.model.program + '-' : '';
      this.fullNumber = `
        ${this.model.account ?? ''}-
        ${this.model.dept ?? ''}-
        ${this.model.fund ?? ''}-
        ${program}
        ${this.model.class ?? ''}-
        ${this.model.budRef ?? ''}-
        ${this.model.pcBusUnit ?? ''}
        ${this.model.project ? '-' + this.model.project : ''}
        ${this.model.activity ? '-' + this.model.activity : ''}`;
    },
    async callGetFigureType() {
      const { data } = await _getFigureType();
      if (data) {
        this.catalog.figureTypes = data;
      }
    },
    validateDate() {
      if (this.model.dateFrom && this.model.dateTo) {
        if (this.model.dateFrom >= this.model.dateTo) {
          this.validations.invalidDate =
            'La fecha desde no puede ser mayor o igual a la fecha hasta.';
          return false;
        } else {
          this.validations.invalidDate = null;
          return true;
        }
      }
    },
    async clearModel() {
      this.fullNumber = '-';
      this.model = { caats: [], figureTypeId: null, figureType: null };
      await this.$refs.accountNumberRef.reset();
    },
    async saveHandler() {
      const isValid = await this.$refs.accountNumberRef.validate();
      const _isValidDate = this.validateDate();

      if (!isValid || !_isValidDate) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
      if (this.isAssistiveTeam && this.model.caats.length === 0) {
        this.ShowToast(
          'Alerta',
          'Favor seleccionar al menos un centro de servicio.',
          'error'
        );
        await this.$refs.caatDropDown.validate();
        return;
      }
      //Set
      const params = {
        ...this.model,
        serviceId: this.isAssistiveTeam ? null : this.model.serviceId?.id,
        figureTypeId: this.model.figureType?.id,
        fullNumber: this.fullNumber,
        hiringTypeCd: this.model.hiringType?.id,
        caats: this.model.caats,
      };

      _savePurchaseOrders(params)
        .then(async () => {
          this.ShowToast(
            'Proceso Exitoso',
            'La cifra de cuenta ha sido guardada exitosamente.',
            'success'
          );
          if (this.model.id) {
            this.$router.go(-1);
          } else {
            this.clearModel();
          }
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    async activeHandler() {
      this.model.isActive = !this.model.isActive;
    },
    async getAllCaats() {
      this.catalog.caats = (await _getServiceCenters()).data;
    },
    async getAllBillingServiceCategories() {
      this.catalog.billingServiceCategories = (
        await _getBillingServiceCategories()
      ).data;
    },
    removeCaatHandler(index) {
      this.model.caats.splice(index, 1);
    },
    async onAddCaatHandler() {
      const isValid = await this.$refs.caatDropDown.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'El centro de servicio es requerido.',
          'error'
        );
        return;
      }

      this.model.caats.push(this.model.caat);
      this.model.caat = null;
      this.$refs.caatDropDown.reset();
    },
    onChangeHiringTypeHandler(value) {
      if (value?.id) {
        this.model.caats = [];
        this.model.caat = null;
      }
    },
    onChangeCaatHandler() {
      this.$forceUpdate();
    },
    onNumberTypeHandler() {
      this.model.project = null;
      this.model.program =
        this.isErpEnabled && this.isFederalAccounting ? '00000000' : null;
      this.model.activity =
        this.isErpEnabled && this.isStateAccounting ? '00000000' : null;
    },
    onEditProjectedFundHandler() {
      this.projectedFundValue = this.fundsUse?.projectedFund;
      this.editProjectedFund = !this.editProjectedFund;
    },
    async onSumbmitProjectedFundHandler() {
      const isValid = await this.$refs.formProjectedFundRef.validate();

      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      const passModel = this.$route.params;

      const { data } = await _updateProjectFound({
        id: parseInt(passModel?.id),
        projectFound: parseInt(this.projectedFundValue),
      });

      if (data) {
        this.ShowToast(
          'Proceso Exitoso',
          'El fondo proyectado ha sido guardado exitosamente.',
          'success'
        );
        var { data: result } = await _getFundsUse(passModel?.id);
        this.fundsUse = result;
        this.projectedFundValue = result?.projectedFund;
        this.editProjectedFund = false;
      }
    },
    async getHiringTypes() {
      const { data } = await _getHiringTypes();
      if (data) {
        this.catalog.hiringTypes = data;
      }
    },
    async getParam() {
      const { data } = await _getSysparameterByNames({
        parameterNames: ['RequisitionERP'],
      });
      this.isErpEnabled =
        data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
    },
  },
};
</script>

<style scoped lang="scss">
.chip {
  border: 1px solid #b7c4bd;
  border-radius: 16px;
  display: inline-block;
  padding: 2px 4px 2px 14px;
  margin: 0 0.5rem 0.5rem 0.5rem;
}
</style>
